var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1162_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1638 26.04C23.2819 26.04 25.8096 23.5123 25.8096 20.3942C25.8096 17.2761 23.2819 14.7483 20.1638 14.7483C17.0457 14.7483 14.5179 17.2761 14.5179 20.3942C14.5179 23.5123 17.0457 26.04 20.1638 26.04Z",
    fill: "url(#paint0_linear_1162_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.023 7.25895C38.023 11.2663 34.7738 14.5179 30.7641 14.5179C28.7869 14.5179 26.994 13.7252 25.6851 12.4439C17.3823 5.4661 10.8054 11.0497 10.8054 11.0497V11.0382C9.87907 11.9116 8.63007 12.4439 7.25894 12.4439C4.39453 12.4439 2.07397 10.121 2.07397 7.25895C2.07397 4.39685 4.39453 2.07398 7.25894 2.07398C8.63007 2.07398 9.87907 2.60631 10.8054 3.47968V3.46816C10.8054 3.46816 17.3777 9.04488 25.6759 2.0809C25.6759 2.07859 25.6828 2.07629 25.6851 2.07398C26.994 0.790418 28.7869 0 30.7641 0C34.7738 0 38.023 3.24924 38.023 7.25895Z",
    fill: "url(#paint1_linear_1162_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5179 30.7411C14.5179 34.7485 11.2686 38 7.25895 38C3.24924 38 0 34.7485 0 30.7411C0 28.7639 0.790418 26.971 2.07398 25.6621C2.07629 25.6598 2.07859 25.6552 2.0809 25.6529C9.04488 17.3523 3.46816 10.7824 3.46816 10.7824H3.47968C2.60631 9.85604 2.07398 8.60704 2.07398 7.2359C2.07398 4.3715 4.39454 2.05094 7.25895 2.05094C10.1233 2.05094 12.4439 4.3715 12.4439 7.2359C12.4439 8.60704 11.9116 9.85604 11.0382 10.7824H11.0497C11.0497 10.7824 5.47301 17.3523 12.437 25.6529C12.4393 25.6552 12.4416 25.6598 12.4439 25.6621C13.7275 26.971 14.5179 28.7639 14.5179 30.7411Z",
    fill: "url(#paint2_linear_1162_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1162_2",
    x1: 15.8845,
    y1: 17.7625,
    x2: 25.5055,
    y2: 23.6757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A40A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#593FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#563B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#523686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D3173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1162_2",
    x1: 2.33437,
    y1: 7.25894,
    x2: 38.2834,
    y2: 7.25894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A40A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#593FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#563B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#523686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D3173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1162_2",
    x1: 7.25895,
    y1: 4.15488,
    x2: 7.25895,
    y2: 36.7072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A40A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#593EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#563B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#513582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D3173"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1162_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.023,
    height: 38,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5281a798fd0ecdfb163fe3171ed4b6ac.svg";
export { ForwardRef as ReactComponent };